<br />
<div class="row">
  <div class="col-md-10 offset-md-2 text-left  col-12">
    <h1 class="title">HOMEPAGE</h1>
  </div>
</div>
<br />
<div class="row">
  <div class="col-md-2"></div>
  <div class="col-md-4 col-12">
    <div *ngIf="menu" class="card">
      <div class="card-body text-center">
        <span class="odp-btn-home-menu" style="font-size:0.9em;"> Role: {{menu.title}} </span>
        <div *ngFor="let option of menu.options" class="row">
          <div class="col-md-10 offset-md-1">
            <button *ngIf="option.inActionMenu" type="button" 
                    class="btn btn-primary btn-block odp-btn-home-menu" [id]="option.id"
                    [hidden]="option.title === 'View/Code Abstract' ? !canUserCode : false"
                    [routerLink]="[option.url]"
                    [queryParams]="option.parameters">
              {{option.title}}{{option.id === 'codeAbstractBtn' && uncodedAbstracts >= 0 ? ' (' + uncodedAbstracts + ' left)' : ''}}
            </button>
            <div *ngIf="option.title === 'View/Code Abstract' && !canUserCode" class="unable-to-code-message">
              {{userCannotCodeMessage}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
